import { getSessionData } from '@/auth/authUtil';
import { MOBILE_PATTERN } from '@/components/validatePatterns';
import { versionPrice } from '@/config';
import { ElButton, ElDialog, ElForm, ElInput, ElMessage, ElScrollbar, isNotEmpty, useForm } from '@qsxy/element-plus-react';
import { useMount } from 'ahooks';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveUpgradeInfo, TableData } from './api';
import './styles.scss';

const Versions = () => {
	const navigate = useNavigate();
	const [formInstance] = useForm<TableData>();
	const [visible, setVisible] = useState(false);

	const [version, setVersion] = useState({});

	useMount(() => {
		const { usage } = getSessionData();
		if (isNotEmpty(usage)) {
			setVersion(usage.versionType);
		}
	});

	/** 提交表单 */
	const onSubmit = useCallback(() => {
		formInstance.validateFields().then((formData: TableData) => {
			saveUpgradeInfo(formData).then(result => {
				if (result) {
					formInstance.resetFields();
					ElMessage.success('提交申请成功，请等待销售与您联系或微信扫描二维码联系我！');
					setVisible(false);
				} else {
					ElMessage.error('提交申请失败！');
				}
			});
		});
	}, [formInstance]);

	return (
		<div className="ttn-index">
			<header className="ttn-layout-header">
				<div className="ttn-topbar">
					<div className="ttn-topbar-left">
						<div className="ttn-layout-header-logo">{<img src={require('@/assets/images/logo.png')}></img>}</div>
						<div className="ttn-layout-header-logo1">{<img src={require('@/assets/images/logo1.png')}></img>}</div>
						<div className="ttn-layout-header-logo2">{<img src={require('@/assets/images/logo2.png')}></img>}</div>
						{/* <div className="ttn-welcome-text">
							<div>
								{appName}&nbsp;&nbsp;{appIntro}
							</div>
						</div> */}
					</div>

					<div className="ttn-topbar-right">
						<span className="ttn-action">
							<span className="ttn-header-notice">
								<ElButton type="info" text onClick={() => navigate('/chat')}>
									返回
								</ElButton>
							</span>
						</span>
					</div>
				</div>
			</header>

			<ElScrollbar height="calc(100vh - 60px)">
				<div className="ttn-versions">
					<div className="price-text">所有版本</div>
					<div className="slogon">您可以在这里了解并选择合适的产品版本</div>
					<div className="version-info">
						{versionPrice.map((item, index) => (
							<div className={classNames('version-info-item', { 'is-active': version === item.versionType })}>
								<div className="name">{item.name}</div>
								<div className="description">*每日奖励{item.extraConversation}次会话</div>
								<div className="conversation-time">
									{item.resetFreq}/{item.conversatonTime}次会话
								</div>
								<div className="knowledge">个人知识库：{item.knowledgeStorage}MB</div>
								<div className="knowledge">每日上传文件：{item.fileUpload}个</div>
								<div className="knowledge">每日深度探索：{item.deepSeek}次</div>
								{index > 1 && version !== '1' ? (
									<div className="ope-btn">
										<ElButton type="primary" plain block size="large" onClick={() => setVisible(true)}>
											升级
										</ElButton>
									</div>
								) : null}
							</div>
						))}
					</div>
				</div>
			</ElScrollbar>

			<ElDialog
				className="upgrade-dialog"
				title="版本升级"
				headerClass="upgrage-title"
				visible={visible}
				close={() => setVisible(false)}
				width={500}
				closeOnClickModal={false}
			>
				<ElDialog.body>
					<div className="tip">提示：填写并提交下列信息，尽快会有工作人员在工作时段与您取得联系。</div>

					<ElForm form={formInstance} labelPosition="top" style={{ maxWidth: 460, marginTop: 20 }}>
						<ElForm.Item name="name" label="姓名" rules={[{ required: true, message: '姓名不得为空' }]}>
							<ElInput placeholder="输入姓名" />
						</ElForm.Item>
						<ElForm.Item
							name="phoneNumber"
							label="手机号码"
							rules={[
								{ required: true, message: '请填写手机号' },
								{ len: 11, message: '请填写11位长度手机号' },
								{ pattern: MOBILE_PATTERN, message: '手机号格式不正确' },
							]}
						>
							<ElInput placeholder="输入手机号码" />
						</ElForm.Item>
						<ElForm.Item name="company" label="公司" rules={[{ required: true, message: '公司不得为空' }]}>
							<ElInput placeholder="输入企业名称" />
						</ElForm.Item>
						<ElForm.Item name="job" label="职务" rules={[{ required: true, message: '职务不得为空' }]}>
							<ElInput placeholder="输入您担任的职务" />
						</ElForm.Item>
						<ElForm.Item label="微信扫描二维码联系我">
							<div className="contact-me">
								<img src={require('@/assets/images/wechat.jpg')} />
							</div>
						</ElForm.Item>
						<ElForm.Item>
							<ElButton type="primary" block size="large" onClick={onSubmit}>
								提交申请
							</ElButton>
						</ElForm.Item>
					</ElForm>
				</ElDialog.body>
			</ElDialog>
		</div>
	);
};

export default Versions;
